<div [ngClass]="['sticky-container', position]" #container>
  <ng-content></ng-content>
</div>
